// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscriptionTab_sspRoot__6ccxj {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
}

.subscriptionTab_sspContainer__9xspk {
  margin: 0 auto;
}

.subscriptionTab_sspTitle__3hARo {
  text-align: center;
  font: var(--h3);
  font-weight: 800;
  margin-bottom: 6px;
  color: var(--primary-Text);
}

.subscriptionTab_sspSubtitle__B63HX {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  text-align: center;
  margin: 0 auto;
  margin-bottom: 30px;
}

.subscriptionTab_sspGrid__P3DC9 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}
.subscriptionTab_sspGrid__P3DC9.subscriptionTab_grid2__CRcgi {
  grid-template-columns: 1fr;
  gap: 20px;
}
.subscriptionTab_sspGrid__P3DC9.subscriptionTab_grid3__JV8Hy {
  grid-template-columns: 1fr;
  gap: 20px;
}

@media (min-width: 992px) {
  .subscriptionTab_sspGrid__P3DC9 {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }
  .subscriptionTab_sspGrid__P3DC9.subscriptionTab_grid2__CRcgi {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
  .subscriptionTab_sspGrid__P3DC9.subscriptionTab_grid3__JV8Hy {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
  }
}
.subscriptionTab_planCard__iZiaI {
  border-radius: var(--border-radius-large);
  padding: 28px;
  background: #ffffff;
  border: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.subscriptionTab_grid3__JV8Hy .subscriptionTab_planCard__iZiaI {
  padding: 18px;
}

@media (max-width: 992px) {
  .subscriptionTab_planCard__iZiaI {
    padding: 18px;
  }
}
@media (max-width: 768px) {
  .subscriptionTab_planCard__iZiaI {
    padding: 12px;
  }
}
.subscriptionTab_planCardPremium__Jf5ss {
  border: 1px solid var(--border);
  background-color: var(--bg3);
}

.subscriptionTab_planTitle__W4\\+8k {
  font: var(--h6);
  font-weight: 800;
  margin-bottom: 8px;
  color: var(--primary-Text);
}

.subscriptionTab_planDesc__NU8xD {
  color: var(--secondary-Text);
  font: var(--body-font-three);
  margin-bottom: 12px;
}

.subscriptionTab_price__nhSiT {
  font: var(--h2);
  font-weight: 800;
  color: var(--brand);
  margin-bottom: 8px;
}

.subscriptionTab_sspDuration__LVL58 {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--primary-Text);
  margin-left: 4px;
}

.subscriptionTab_currentBadge__rxyAH {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: #d1fae5;
  color: #065f46;
  font: var(--body-font-three);
  font-weight: 700;
  border: 1px solid var(--border);
  border-right: 0;
  border-radius: 0 0 0 8px;
  border-top: 0;
  box-shadow: 0px 0px 20px 6px rgba(0, 0, 0, 0.09);
  position: absolute;
  top: 0;
  right: 0;
}

.subscriptionTab_sectionTitle__TuFIT {
  margin: 16px 0 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--border);
  font: var(--body-font-two);
  font-weight: 700;
  color: var(--primary-Text);
}

.subscriptionTab_sspFeatures__SKK95 {
  list-style: none;
  padding: 0;
  padding-bottom: 10px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.subscriptionTab_sspFeature__sRCdA {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: #0f172a;
  font: var(--body-font-three);
}
.subscriptionTab_sspFeature__sRCdA img {
  width: 18px;
  height: 18px;
}

.subscriptionTab_sspFeatureComingSoon__6iDBO {
  opacity: 0.75;
  font-style: italic;
  color: #6b7280;
}

.subscriptionTab_sspFeatureIcon__ZXc\\+Q {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4f46e5;
}

.subscriptionTab_sspFeatureText__YAf0u {
  line-height: 1.35;
}

.subscriptionTab_bestFor__zWTCZ {
  margin-top: auto;
  margin-bottom: 20px;
  padding-top: 18px;
  border-top: 1px solid var(--border);
  color: #475569;
  font: var(--body-font-three);
}
.subscriptionTab_bestFor__zWTCZ:empty {
  padding-top: 0;
}
.subscriptionTab_bestFor__zWTCZ strong {
  font-weight: 700;
}

.subscriptionTab_sspBtn__w2ejB {
  width: 100%;
  font-weight: 700;
  cursor: pointer;
}

.subscriptionTab_sspBtnPrimary__W9QYA {
  background: linear-gradient(90deg, #6d28d9, #9333ea);
  color: #fff;
  box-shadow: 0 8px 28px rgba(99, 102, 241, 0.18);
}

.subscriptionTab_sspBtn__w2ejB:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.subscriptionTab_sspCtaButtons__Unv6H {
  margin-top: 10px;
  display: flex;
  gap: 0.5em;
}

@media (max-width: 480px) {
  .subscriptionTab_sspCtaButtons__Unv6H {
    flex-direction: column;
  }
}
.subscriptionTab_paymentMethodsModalInner__WXeVN {
  max-width: 900px !important;
  width: 95%;
}
@media screen and (min-width: 1200px) {
  .subscriptionTab_paymentMethodsModalInner__WXeVN {
    max-width: 1100px !important;
  }
}
@media screen and (min-width: 1440px) {
  .subscriptionTab_paymentMethodsModalInner__WXeVN {
    max-width: 1200px !important;
  }
}
@media screen and (max-width: 767px) {
  .subscriptionTab_paymentMethodsModalInner__WXeVN {
    max-width: 95% !important;
    width: 95%;
  }
}

.subscriptionTab_paymentMethodsContainer__EQmJE {
  max-height: calc(100vh - 280px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
  margin-right: -8px;
}
.subscriptionTab_paymentMethodsContainer__EQmJE::-webkit-scrollbar {
  width: 6px;
}
.subscriptionTab_paymentMethodsContainer__EQmJE::-webkit-scrollbar-track {
  background: var(--border);
  border-radius: 3px;
}
.subscriptionTab_paymentMethodsContainer__EQmJE::-webkit-scrollbar-thumb {
  background: var(--secondary-Text);
  border-radius: 3px;
}
.subscriptionTab_paymentMethodsContainer__EQmJE::-webkit-scrollbar-thumb:hover {
  background: var(--primary-Text);
}
@media screen and (max-width: 767px) {
  .subscriptionTab_paymentMethodsContainer__EQmJE {
    max-height: calc(100vh - 250px);
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .subscriptionTab_paymentMethodsContainer__EQmJE {
    max-height: calc(100vh - 300px);
  }
}
@media screen and (min-width: 1025px) and (max-width: 1439px) {
  .subscriptionTab_paymentMethodsContainer__EQmJE {
    max-height: calc(100vh - 320px);
  }
}
@media screen and (min-width: 1440px) {
  .subscriptionTab_paymentMethodsContainer__EQmJE {
    max-height: calc(100vh - 340px);
  }
}

.subscriptionTab_paymentMethodsModalBtn__7BymD {
  width: fit-content !important;
  margin: 0 auto !important;
}`, "",{"version":3,"sources":["webpack://./src/components/settingsTabs/SubscriptionPages/subscriptionTab.module.scss"],"names":[],"mappings":"AAAA;EACI,wGAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AACJ;;AAEA;EACI,4BAAA;EACA,4BAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,0BAAA;EACA,SAAA;AACJ;AACI;EACI,0BAAA;EACA,SAAA;AACR;AAEI;EACI,0BAAA;EACA,SAAA;AAAR;;AAIA;EACI;IACI,8BAAA;IACA,SAAA;EADN;EAGM;IACI,8BAAA;IACA,SAAA;EADV;EAIM;IACI,kCAAA;IACA,SAAA;EAFV;AACF;AAMA;EACI,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;;AAQI;EACI,aAAA;AALR;;AASA;EACI;IACI,aAAA;EANN;AACF;AASA;EACI;IACI,aAAA;EAPN;AACF;AAUA;EACI,+BAAA;EACA,4BAAA;AARJ;;AAWA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AARJ;;AAWA;EACI,4BAAA;EACA,4BAAA;EACA,mBAAA;AARJ;;AAWA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;AARJ;;AAWA;EACI,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,4BAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,wBAAA;EACA,aAAA;EACA,gDAAA;EAEA,kBAAA;EACA,MAAA;EACA,QAAA;AATJ;;AAYA;EACI,mBAAA;EACA,oBAAA;EACA,sCAAA;EACA,0BAAA;EACA,gBAAA;EACA,0BAAA;AATJ;;AAYA;EACI,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AATJ;;AAYA;EACI,aAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,4BAAA;AATJ;AAWI;EACI,WAAA;EACA,YAAA;AATR;;AAaA;EACI,aAAA;EACA,kBAAA;EACA,cAAA;AAVJ;;AAaA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAVJ;;AAaA;EACI,iBAAA;AAVJ;;AAaA;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mCAAA;EACA,cAAA;EACA,4BAAA;AAVJ;AAYI;EACI,cAAA;AAVR;AAaI;EACI,gBAAA;AAXR;;AAeA;EACI,WAAA;EACA,gBAAA;EACA,eAAA;AAZJ;;AAeA;EACI,oDAAA;EACA,WAAA;EACA,+CAAA;AAZJ;;AAeA;EACI,aAAA;EACA,mBAAA;AAZJ;;AAeA;EACI,gBAAA;EACA,aAAA;EACA,UAAA;AAZJ;;AAeA;EACI;IACI,sBAAA;EAZN;AACF;AAeA;EACC,2BAAA;EACA,UAAA;AAbD;AAeC;EAJD;IAKE,4BAAA;EAZA;AACF;AAcC;EARD;IASE,4BAAA;EAXA;AACF;AAaC;EAZD;IAaE,yBAAA;IACA,UAAA;EAVA;AACF;;AAaA;EACC,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAVD;AAYC;EACC,UAAA;AAVF;AAaC;EACC,yBAAA;EACA,kBAAA;AAXF;AAcC;EACC,iCAAA;EACA,kBAAA;AAZF;AAcE;EACC,+BAAA;AAZH;AAgBC;EAzBD;IA0BE,+BAAA;EAbA;AACF;AAeC;EA7BD;IA8BE,+BAAA;EAZA;AACF;AAcC;EAjCD;IAkCE,+BAAA;EAXA;AACF;AAaC;EArCD;IAsCE,+BAAA;EAVA;AACF;;AAaA;EACI,6BAAA;EACA,yBAAA;AAVJ","sourcesContent":[".sspRoot {\r\n    font-family: Inter, ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;\r\n}\r\n\r\n.sspContainer {\r\n    margin: 0 auto;\r\n}\r\n\r\n.sspTitle {\r\n    text-align: center;\r\n    font: var(--h3);\r\n    font-weight: 800;\r\n    margin-bottom: 6px;\r\n    color: var(--primary-Text);\r\n}\r\n\r\n.sspSubtitle {\r\n    font: var(--body-font-three);\r\n    color: var(--secondary-Text);\r\n    text-align: center;\r\n    margin: 0 auto;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.sspGrid {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    gap: 24px;\r\n\r\n    &.grid2 {\r\n        grid-template-columns: 1fr;\r\n        gap: 20px;\r\n    }\r\n\r\n    &.grid3 {\r\n        grid-template-columns: 1fr;\r\n        gap: 20px;\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .sspGrid {\r\n        grid-template-columns: 1fr 1fr;\r\n        gap: 32px;\r\n\r\n        &.grid2 {\r\n            grid-template-columns: 1fr 1fr;\r\n            gap: 20px;\r\n        }\r\n\r\n        &.grid3 {\r\n            grid-template-columns: 1fr 1fr 1fr;\r\n            gap: 20px;\r\n        }\r\n    }\r\n}\r\n\r\n.planCard {\r\n    border-radius: var(--border-radius-large);\r\n    padding: 28px;\r\n    background: #ffffff;\r\n    border: 1px solid var(--border);\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.grid3 {\r\n    .planCard {\r\n        padding: 18px;\r\n    }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .planCard {\r\n        padding: 18px;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .planCard {\r\n        padding: 12px;\r\n    }\r\n}\r\n\r\n.planCardPremium {\r\n    border: 1px solid var(--border);\r\n    background-color: var(--bg3);\r\n}\r\n\r\n.planTitle {\r\n    font: var(--h6);\r\n    font-weight: 800;\r\n    margin-bottom: 8px;\r\n    color: var(--primary-Text);\r\n}\r\n\r\n.planDesc {\r\n    color: var(--secondary-Text);\r\n    font: var(--body-font-three);\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.price {\r\n    font: var(--h2);\r\n    font-weight: 800;\r\n    color: var(--brand);\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.sspDuration {\r\n    font: var(--body-font-three);\r\n    font-weight: 500;\r\n    color: var(--primary-Text);\r\n    margin-left: 4px;\r\n}\r\n\r\n.currentBadge {\r\n    display: inline-flex;\r\n    width: fit-content;\r\n    align-items: center;\r\n    padding: 4px 10px;\r\n    border-radius: 999px;\r\n    background: #d1fae5;\r\n    color: #065f46;\r\n    font: var(--body-font-three);\r\n    font-weight: 700;\r\n    border: 1px solid var(--border);\r\n    border-right: 0;\r\n    border-radius: 0 0 0 8px;\r\n    border-top: 0;\r\n    box-shadow: 0px 0px 20px 6px rgb(0 0 0 / 9%);\r\n\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n}\r\n\r\n.sectionTitle {\r\n    margin: 16px 0 10px;\r\n    padding-bottom: 10px;\r\n    border-bottom: 1px solid var(--border);\r\n    font: var(--body-font-two);\r\n    font-weight: 700;\r\n    color: var(--primary-Text);\r\n}\r\n\r\n.sspFeatures {\r\n    list-style: none;\r\n    padding: 0;\r\n    padding-bottom: 10px;\r\n    margin: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.sspFeature {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n    color: #0f172a;\r\n    font: var(--body-font-three);\r\n\r\n    img {\r\n        width: 18px;\r\n        height: 18px;\r\n    }\r\n}\r\n\r\n.sspFeatureComingSoon {\r\n    opacity: 0.75;\r\n    font-style: italic;\r\n    color: #6b7280;\r\n}\r\n\r\n.sspFeatureIcon {\r\n    width: 28px;\r\n    height: 28px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: #4f46e5;\r\n}\r\n\r\n.sspFeatureText {\r\n    line-height: 1.35;\r\n}\r\n\r\n.bestFor {\r\n    margin-top: auto;\r\n    margin-bottom: 20px;\r\n    padding-top: 18px;\r\n    border-top: 1px solid var(--border);\r\n    color: #475569;\r\n    font: var(--body-font-three);\r\n\r\n    &:empty {\r\n        padding-top: 0;\r\n    }\r\n\r\n    strong {\r\n        font-weight: 700;\r\n    }\r\n}\r\n\r\n.sspBtn {\r\n    width: 100%;\r\n    font-weight: 700;\r\n    cursor: pointer;\r\n}\r\n\r\n.sspBtnPrimary {\r\n    background: linear-gradient(90deg, #6d28d9, #9333ea);\r\n    color: #fff;\r\n    box-shadow: 0 8px 28px rgba(99, 102, 241, 0.18);\r\n}\r\n\r\n.sspBtn:disabled {\r\n    opacity: 0.65;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.sspCtaButtons {\r\n    margin-top: 10px;\r\n    display: flex;\r\n    gap: 0.5em;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .sspCtaButtons {\r\n        flex-direction: column;\r\n    }\r\n}\r\n\r\n.paymentMethodsModalInner {\r\n\tmax-width: 900px !important;\r\n\twidth: 95%;\r\n\r\n\t@media screen and (min-width: 1200px) {\r\n\t\tmax-width: 1100px !important;\r\n\t}\r\n\r\n\t@media screen and (min-width: 1440px) {\r\n\t\tmax-width: 1200px !important;\r\n\t}\r\n\r\n\t@media screen and (max-width: 767px) {\r\n\t\tmax-width: 95% !important;\r\n\t\twidth: 95%;\r\n\t}\r\n}\r\n\r\n.paymentMethodsContainer {\r\n\tmax-height: calc(100vh - 280px);\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n\tpadding-right: 8px;\r\n\tmargin-right: -8px;\r\n\r\n\t&::-webkit-scrollbar {\r\n\t\twidth: 6px;\r\n\t}\r\n\r\n\t&::-webkit-scrollbar-track {\r\n\t\tbackground: var(--border);\r\n\t\tborder-radius: 3px;\r\n\t}\r\n\r\n\t&::-webkit-scrollbar-thumb {\r\n\t\tbackground: var(--secondary-Text);\r\n\t\tborder-radius: 3px;\r\n\r\n\t\t&:hover {\r\n\t\t\tbackground: var(--primary-Text);\r\n\t\t}\r\n\t}\r\n\r\n\t@media screen and (max-width: 767px) {\r\n\t\tmax-height: calc(100vh - 250px);\r\n\t}\r\n\r\n\t@media screen and (min-width: 768px) and (max-width: 1024px) {\r\n\t\tmax-height: calc(100vh - 300px);\r\n\t}\r\n\r\n\t@media screen and (min-width: 1025px) and (max-width: 1439px) {\r\n\t\tmax-height: calc(100vh - 320px);\r\n\t}\r\n\r\n\t@media screen and (min-width: 1440px) {\r\n\t\tmax-height: calc(100vh - 340px);\r\n\t}\r\n}\r\n\r\n.paymentMethodsModalBtn {\r\n    width: fit-content !important;\r\n    margin: 0 auto !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sspRoot": `subscriptionTab_sspRoot__6ccxj`,
	"sspContainer": `subscriptionTab_sspContainer__9xspk`,
	"sspTitle": `subscriptionTab_sspTitle__3hARo`,
	"sspSubtitle": `subscriptionTab_sspSubtitle__B63HX`,
	"sspGrid": `subscriptionTab_sspGrid__P3DC9`,
	"grid2": `subscriptionTab_grid2__CRcgi`,
	"grid3": `subscriptionTab_grid3__JV8Hy`,
	"planCard": `subscriptionTab_planCard__iZiaI`,
	"planCardPremium": `subscriptionTab_planCardPremium__Jf5ss`,
	"planTitle": `subscriptionTab_planTitle__W4+8k`,
	"planDesc": `subscriptionTab_planDesc__NU8xD`,
	"price": `subscriptionTab_price__nhSiT`,
	"sspDuration": `subscriptionTab_sspDuration__LVL58`,
	"currentBadge": `subscriptionTab_currentBadge__rxyAH`,
	"sectionTitle": `subscriptionTab_sectionTitle__TuFIT`,
	"sspFeatures": `subscriptionTab_sspFeatures__SKK95`,
	"sspFeature": `subscriptionTab_sspFeature__sRCdA`,
	"sspFeatureComingSoon": `subscriptionTab_sspFeatureComingSoon__6iDBO`,
	"sspFeatureIcon": `subscriptionTab_sspFeatureIcon__ZXc+Q`,
	"sspFeatureText": `subscriptionTab_sspFeatureText__YAf0u`,
	"bestFor": `subscriptionTab_bestFor__zWTCZ`,
	"sspBtn": `subscriptionTab_sspBtn__w2ejB`,
	"sspBtnPrimary": `subscriptionTab_sspBtnPrimary__W9QYA`,
	"sspCtaButtons": `subscriptionTab_sspCtaButtons__Unv6H`,
	"paymentMethodsModalInner": `subscriptionTab_paymentMethodsModalInner__WXeVN`,
	"paymentMethodsContainer": `subscriptionTab_paymentMethodsContainer__EQmJE`,
	"paymentMethodsModalBtn": `subscriptionTab_paymentMethodsModalBtn__7BymD`
};
export default ___CSS_LOADER_EXPORT___;
